import type { JSX } from 'react';
import { useState } from 'react';
import { MoreHorizontal } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import type { CandidateStatus } from '../types/candidate.types';
import { CandidateConfirmDialogs } from './CandidateConfirmDialogs';
import { CandidateActionsMenu } from './CandidateActionsMenu';
import type { CandidateActionsProps } from './CandidateActions.utils';
export function CandidateActions({
  candidate,
  onEdit,
  onDelete,
  onStatusChange,
  onResendInvitation,
  onCopyLink,
}: CandidateActionsProps): JSX.Element {
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [showStatusConfirm, setShowStatusConfirm] = useState(false);
  const [pendingStatus, setPendingStatus] = useState<CandidateStatus | null>(null);
  const handleStatusClick = (status: CandidateStatus): void => {
    setPendingStatus(status);
    setShowStatusConfirm(true);
  };
  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="sm" aria-label="Actions">
            <MoreHorizontal className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <CandidateActionsMenu
            candidateId={candidate.id}
            shareId={candidate.shareId}
            status={candidate.status}
            onEdit={() => onEdit(candidate)}
            onResendInvitation={onResendInvitation}
            onCopyLink={onCopyLink}
            onDelete={() => setShowDeleteConfirm(true)}
            onStatusClick={handleStatusClick}
          />
        </DropdownMenuContent>
      </DropdownMenu>
      <CandidateConfirmDialogs
        candidateName={candidate.name}
        candidateId={candidate.id}
        showDeleteConfirm={showDeleteConfirm}
        onDeleteConfirmChange={setShowDeleteConfirm}
        onDelete={onDelete}
        showStatusConfirm={showStatusConfirm}
        onStatusConfirmChange={setShowStatusConfirm}
        pendingStatus={pendingStatus}
        onStatusConfirm={() => pendingStatus && onStatusChange(candidate.id, pendingStatus)}
      />
    </>
  );
}
